import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Input,
  InputGroup,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  getEmployees,
  deleteEmployee,
  resetEmployees,
  updateEmployeeState,
} from "../../../../store/employee/actions";
import { getStores } from "../../../../store/store/actions";
import { layout, messages } from "../../../../common/constants";
import {
  DataTable,
  TableRowField,
  ExportCSV,
  MainLoader,
} from "../../../../components";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { formatHelper } from "../../../../common/helpers";
import MediaQuery from "react-responsive";
import { getAll as allEmployeesExport } from "../../../../service/employee";
import Select from "react-select";
import { selectStoresForSelect } from "../../../../store/store/selector";
import { exportExcel } from "./excel";

class EmployeeList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      filter: "",
      loadingExport: false,
      selectedStore: null,
    };
    this.handleObtainEmployeesExport =
      this.handleObtainEmployeesExport.bind(this);

    this.optionsFormatterColumn = this.optionsFormatterColumn.bind(this);
    this.handleInputFilterChange = this.handleInputFilterChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleStoreChange = this.handleStoreChange.bind(this);
  }

  async componentDidMount() {
    this.props.getStores({ reset: true });
    this.performGetEmployees(true);
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
      this.setState({ selectedStore: this.props.stores[0] });
    }
    this.checkEmployeeDelete(prevProps);
    this.checkEmployeeUpdateState(prevProps);
  }

  componentWillUnmount() {
    this.props.resetEmployees();
  }

  async checkEmployeeDelete(prevProps) {
    if (
      prevProps.deletedEmployee == null &&
      this.props.deletedEmployee != null
    ) {
      toast.success("Empleado eliminado satisfactoriamente");
      await this.setState({ page: 1 });
      this.performGetEmployees();
    } else if (
      prevProps.deleteError == null &&
      this.props.deleteError != null
    ) {
      toast.error(this.props.deleteError);
    }
  }

  async checkEmployeeUpdateState(prevProps) {
    if (
      prevProps.updatedStateSuccess != true &&
      this.props.updatedStateSuccess == true
    ) {
      toast.success("Estado cambiado satisfactoriamente");
      await this.setState({ page: 1 });
      this.performGetEmployees();
    } else if (
      prevProps.deleteError == null &&
      this.props.deleteError != null
    ) {
      toast.error(this.props.deleteError);
    }
  }

  performGetEmployees(reset = false) {
    const { page, filter, selectedStore } = this.state;
    const storeId =
      selectedStore == null || selectedStore.value == 0
        ? null
        : selectedStore.value;
    this.props.getEmployees({ page, filter, reset, storeId });
  }

  async filterEmployees() {
    await this.setState({ page: 1 });
    this.performGetEmployees();
  }

  async handleStoreChange(value) {
    if (value == this.state.selectedStore) return;
    await this.setState({ selectedStore: value, page: 1 });
    this.performGetEmployees();
  }
  handleInputFilterChange(e) {
    if (e.key === "Enter") {
      this.filterEmployees();
    }
  }

  async handlePageChange(page) {
    await this.setState({ page: page });
    this.performGetEmployees();
  }

  optionsFormatterColumn(cell, row) {
    return (
      <UncontrolledButtonDropdown>
        <DropdownToggle size="sm" color="primary">
          <i className="fa fa-bars"></i>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem
            onClick={() =>
              this.props.history.push(
                `/administration/employees/${row.id}/detail`
              )
            }
          >
            <i className="fa fa-eye mr-1"></i> Detalle
          </DropdownItem>
          <DropdownItem
            onClick={() =>
              this.props.history.push(
                `/administration/employees/${row.id}/edit`
              )
            }
          >
            <i className="fa fa-edit mr-1"></i> Editar
          </DropdownItem>
          <DropdownItem
            disabled={this.props.updateStateLoading}
            onClick={() => this.performUpdateEmployeeState(row.id, row.state)}
          >
            <i className="fa fa-exclamation-triangle mr-1"></i>{" "}
            {row.state == "ACT" ? "Desactivar" : "Activar"}
          </DropdownItem>
          <DropdownItem
            disabled={this.props.deleteLoading}
            onClick={() => this.performDeleteEmployee(row.id)}
          >
            <i className="fa fa-trash mr-1"></i> Eliminar
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    );
  }

  performDeleteEmployee(id) {
    Swal({
      title: "Eliminar empleado",
      text: "¿Estás seguro que deseas eliminar al empleado?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.value) {
        this.props.deleteEmployee(id);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  performUpdateEmployeeState(id, state) {
    const isActive = state == "ACT" ? true : false;
    const swalState = isActive == true ? "Desactivar" : "Activar";
    Swal({
      title: swalState + " empleado",
      text:
        "¿Estás seguro que deseas " + swalState.toLowerCase() + " al empleado?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: swalState,
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.value) {
        this.props.updateEmployeeState(id, isActive);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  renderDataTable(columns) {
    return (
      <DataTable
        data={this.props.employees}
        keyField="id"
        columns={columns}
        page={this.state.page}
        totalSize={this.props.total}
        sizePerPage={this.props.pageSize}
        loading={this.props.loading}
        onPageChange={this.handlePageChange}
      />
    );
  }

  handleObtainEmployeesExport() {
    const store =
      this.state.selectedStore == null || this.state.selectedStore.value == 0
        ? null
        : this.state.selectedStore.value;
    this.setState({ loadingExport: true });
    allEmployeesExport(0, null, store)
      .then((response) => {
        exportExcel(response.data.data);
      })
      .finally(() => {
        this.setState({ loadingExport: false });
      });
  }

  render() {
    const columnOption = {
      dataField: "",
      text: "",
      formatter: this.optionsFormatterColumn,
      style: { width: "50px" },
      headerStyle: { width: "50px" },
    };

    const columnsXS = [
      {
        dataField: "id",
        text: "Empleado",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="Nombre:" value={row.name} />
              <TableRowField label="Apellidos:" value={row.lastname} />
              <TableRowField label="DNI:" value={row.dni} />
              <TableRowField label="Teléfono:" value={row.cellphone} />
              <TableRowField label="Email:" value={row.email} />
            </div>
          );
        },
      },
      columnOption,
    ];

    const columnsSM = [
      {
        dataField: "id",
        text: "Empleado",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="Nombre:" value={row.name} />
              <TableRowField label="Apellidos:" value={row.lastname} />
              <TableRowField label="DNI:" value={row.dni} />
            </div>
          );
        },
      },
      {
        dataField: "cellphone",
        text: "Teléfono",
      },
      {
        dataField: "email",
        text: "Email",
      },
      columnOption,
    ];

    const columns = [
      {
        dataField: "name",
        text: "Nombre",
      },
      {
        dataField: "lastname",
        text: "Apellidos",
      },
      {
        dataField: "dni",
        text: "DNI",
      },
      {
        dataField: "cellphone",
        text: "Teléfono",
      },
      {
        dataField: "email",
        text: "Email",
      },
      columnOption,
    ];
    if (this.props.loading) {
      return <MainLoader />;
    }
    return (
      <div className="animated">
        <Card>
          <CardHeader>
            <i className="icon-people"></i>Empleados
          </CardHeader>
          <CardBody>
            <MediaQuery minDeviceWidth={600}>
              {(matches) => {
                if (matches) {
                  return (
                    <Row className="mb-2">
                      <Col sm="4">
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          isLoading={this.props.loadingStores}
                          isSearchable={true}
                          noOptionsMessage={() => {
                            return messages.SELECT_NO_OPTIONS;
                          }}
                          placeholder=""
                          options={this.props.stores}
                          loadingMessage={() => {
                            return messages.SELECT_LOADING;
                          }}
                          onChange={this.handleStoreChange}
                          value={this.state.selectedStore}
                          isDisabled={this.props.loadingStores}
                        />
                      </Col>
                      <Col sm="4">
                        <InputGroup>
                          <Input
                            type="text"
                            id="input1-group2"
                            name="input1-group2"
                            placeholder="Buscar"
                            value={this.state.filter}
                            onChange={(e) =>
                              this.setState({ filter: e.target.value })
                            }
                            onKeyPress={this.handleInputFilterChange}
                          />
                          <div className="input-group-prepend">
                            <Button
                              type="button"
                              color="primary"
                              onClick={() => this.filterEmployees()}
                            >
                              <i className="fa fa-search"></i>
                            </Button>
                          </div>
                        </InputGroup>
                      </Col>
                      <Col sm="4">
                        <ExportCSV
                          disabled={this.state.loadingExport}
                          exportCSV={this.handleObtainEmployeesExport}
                        />
                      </Col>
                    </Row>
                  );
                } else {
                  return (
                    <Row className="mb-2">
                      <Col md="5">
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          isLoading={this.props.loadingStores}
                          isSearchable={true}
                          noOptionsMessage={() => {
                            return messages.SELECT_NO_OPTIONS;
                          }}
                          placeholder=""
                          options={this.props.stores}
                          loadingMessage={() => {
                            return messages.SELECT_LOADING;
                          }}
                          onChange={this.handleStoreChange}
                          value={this.state.selectedStore}
                          isDisabled={this.props.loadingStores}
                        />
                      </Col>
                      <Col md="5">
                        <InputGroup>
                          <Input
                            type="text"
                            id="input1-group2"
                            name="input1-group2"
                            placeholder="Buscar"
                            value={this.state.filter}
                            onChange={(e) =>
                              this.setState({ filter: e.target.value })
                            }
                            onKeyPress={this.handleInputFilterChange}
                          />
                          <div className="input-group-prepend">
                            <Button
                              type="button"
                              color="primary"
                              onClick={() => this.filterEmployees()}
                            >
                              <i className="fa fa-search"></i>
                            </Button>
                          </div>
                        </InputGroup>
                      </Col>
                      <Col md="2">
                        <ExportCSV
                          disabled={this.state.loadingExport}
                          exportCSV={this.handleObtainEmployeesExport}
                        />
                      </Col>
                    </Row>
                  );
                }
              }}
            </MediaQuery>
            <hr className="my-4" />
            <Row className="mb-2">
              <Col>
                <div className="float-right">
                  <Button
                    color="primary"
                    onClick={() =>
                      this.props.history.push("/administration/employees/add")
                    }
                  >
                    <i className="fa fa-plus mr-1"></i> Nuevo
                  </Button>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                  {this.renderDataTable(columnsXS)}
                </MediaQuery>
                <MediaQuery
                  minWidth={layout.SM_MIN_WIDTH}
                  maxWidth={layout.MD_MAX_WIDTH}
                >
                  {this.renderDataTable(columnsSM)}
                </MediaQuery>
                <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                  {this.renderDataTable(columns)}
                </MediaQuery>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { employees, error, loading, pageSize, total } =
    state.employee.employeeList;

  return {
    employees,
    error,
    loading,
    pageSize,
    total,
    deletedEmployee: state.employee.deleteEmployee.employee,
    deleteError: state.employee.deleteEmployee.error,
    deleteLoading: state.employee.deleteEmployee.loading,
    updatedStateSuccess: state.employee.updateState.success,
    updateStateLoading: state.employee.updateState.loading,
    updateStateError: state.employee.updateState.error,
    stores: selectStoresForSelect(state),
    loadingStores: state.store.storeList.loading,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getEmployees,
      deleteEmployee,
      resetEmployees,
      updateEmployeeState,
      getStores,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeList);



// WEBPACK FOOTER //
// ./src/scenes/Administration/Employee/EmployeeList/EmployeeList.js